import * as React from 'react';
import Tabs from '../Tabs/Tabs';
import Strings from '../../globals/Strings';

export default ({commentTabSelected, commentsCount, setCommentTabSelected}: CommentTabsProps) => {
   const commentsTab = {
      text: commentsCount !== 1 ? Strings.tabs.review.comments.replace('{param0}', commentsCount.toString()) : Strings.tabs.review.comment,
      onClick: () => setCommentTabSelected(true),
      selected: commentTabSelected,
      href: ''
   };
   const detailsTab = {
      text: Strings.tabs.review.details,
      onClick: () => setCommentTabSelected(false),
      selected: !commentTabSelected,
      href: ''
   };

   return (
      <Tabs tabs={[commentsTab, detailsTab]}
         isAnchor={false}/>
   );
};

export interface CommentTabsProps {
   commentTabSelected: boolean;
   commentsCount: number;
   setCommentTabSelected(isSelected: boolean): void;
}
